/**
 * @param {HTMLElement} errorContent - The error message element
 * @param {string} message - The error message to display
 * @returns {string}
 */

const errorMessage = async (errorContent, message) => {
  errorContent.dataset.errorMessage = message;
  errorContent.classList.add('show');

  await new Promise(resolve => setTimeout(resolve, 3000));

  errorContent.classList.remove('show');
  errorContent.dataset.errorMessage = '';
};

export { errorMessage };
